import React, { Fragment } from 'react'

import styles from './Training.module.css'
import EmptyAnswers from 'Icons/empty-answers.svg'

import PageHead, { PageHeading } from 'Layout/PageHead'
import PageContent from 'Layout/PageContent'
import PageLoader from 'Layout/PageLoader'
import NoContent from 'Layout/NoContent'

import TrainingList from './TrainingList'
import { useListTrainingQuery } from './training.service'
import { useGetTrainingListWithAIQuery } from './trainingWithAI.service'
import accountApi from 'Services/account'
import TrainingListWithAI from './TrainingListWithAI'

const noContentProps = {
  heading: 'No search phrases yet',
  description: 'Install the widget to see what questions customers ask your Bot',
  ctaButtonText: 'Check for updates',
  icon: EmptyAnswers
}

const TrainingContent = () => {
  const { isLoading, data: trainingList, refetch } = useListTrainingQuery()

  if (isLoading) {
    return <PageLoader />
  }

  if (!trainingList || !trainingList.meta.total) {
    return <NoContent {...noContentProps} onClick={refetch} />
  }

  return <TrainingList />
}

const TrainingContentWithAI = () => {
  const { isLoading, data: trainingListWithAI, refetch } = useGetTrainingListWithAIQuery()

  if (isLoading) {
    return <PageLoader />
  }

  if (!trainingListWithAI || !trainingListWithAI.meta.total) {
    return <NoContent {...noContentProps} onClick={refetch} />
  }

  return <TrainingListWithAI />
}

const Training = () => {
  const { data: account = {}, isLoading } = accountApi.useGetAccountQuery()
  const { settings: { ai_predictions: isAIPredictionsEnabled } = {} } = account

  if (isLoading) return <PageLoader />

  return (
    <Fragment>
      <PageHead>
        <PageHeading>Training</PageHeading>
      </PageHead>
      <PageContent className={styles.TrainingView}>
        {!isAIPredictionsEnabled && <TrainingContent />}
        {isAIPredictionsEnabled && <TrainingContentWithAI />}
      </PageContent>
    </Fragment>
  )
}

export default Training
